import React from 'react';
import { Box, Typography, Button, Chip } from '@mui/material';
import { TypeAnimation } from 'react-type-animation';
import ParticleBackground from './ParticleBackground';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

function HomeSection() {
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        width: '100%',
        background: 'radial-gradient(circle at top left, #112244, #0c1e3c)',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        px: { xs: 2, sm: 4 },
        py: { xs: 6, md: 10 },
      }}
    >
      {/* 🔹 Particles Behind */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 0,
        }}
      >
        <ParticleBackground />
      </Box>

      {/* 🔹 Central Content */}
      <Box
        sx={{
          zIndex: 2,
          maxWidth: '900px',
          color: '#ffffff',
          fontFamily: "'Space Grotesk', 'Poppins', sans-serif",
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Chip
          label="⚡ AI-Driven Learning"
          sx={{
            backgroundColor: '#ffcb05',
            color: '#0c1e3c',
            fontWeight: 600,
            fontSize: '0.85rem',
            mb: 2,
            px: 1.5,
          }}
        />

        <TypeAnimation
          sequence={[
            'Welcome to Spark AI Edutech Solutions',
            1500,
            'Empowering Minds. Transforming Futures with AI',
            1500,
            'Learn. Build. Grow with Spark AI Edutech Solutions',
            1500,
          ]}
          speed={50}
          repeat={Infinity}
          style={{
            fontSize: 'clamp(1.8rem, 5vw, 3rem)',
            fontWeight: 'bold',
            marginBottom: '1.2rem',
            lineHeight: '1.3',
            display: 'block',
            textShadow: '0px 0px 8px rgba(255, 255, 255, 0.1)',
          }}
        />

        <Typography
          variant="subtitle1"
          sx={{
            fontStyle: 'italic',
            color: '#ffcb05',
            borderLeft: '4px solid #ffcb05',
            pl: 2,
            mx: 'auto',
            fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' },
            fontWeight: 500,
            mb: { xs: 3, md: 4 },
            maxWidth: '700px',
          }}
        >
          "Code your way into the future."
        </Typography>

        <Button
          variant="contained"
          sx={{
            background: 'linear-gradient(to right, #ffcb05, #ffe873)',
            color: '#0c1e3c',
            fontWeight: 'bold',
            fontSize: { xs: '0.95rem', sm: '1rem' },
            px: { xs: 3, sm: 4 },
            py: { xs: 1.2, sm: 1.5 },
            borderRadius: '30px',
            textTransform: 'none',
            boxShadow: '0px 4px 15px rgba(255, 203, 5, 0.3)',
            '&:hover': {
              background: '#f7be03',
            },
            mt: 2,
            mb: 4,
          }}
          onClick={() =>
            window.open('https://www.linkedin.com/company/spark-ai-edu-tech/', '_blank')
          }
        >
          Join Us on LinkedIn
        </Button>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '0.9rem', sm: '1rem' },
            color: '#cfcfcf',
            lineHeight: 1.6,
            mt: 2,
            maxWidth: '700px',
            mx: 'auto',
            borderTop: '1px solid #444',
            pt: 2,
          }}
        >
          "We don’t predict the future. We empower you to create it".—{' '}
          <strong style={{ color: '#ffcb05', fontWeight: 600 }}>SUMANTH K, <br></br>Founder &CEO</strong>
        </Typography>
      </Box>

      {/* 🔽 Scroll Down Icon */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 24,
          left: '50%',
          transform: 'translateX(-50%)',
          animation: 'bounce 2s infinite',
          zIndex: 2,
          color: '#ffcb05',
        }}
      >
        <KeyboardArrowDownIcon sx={{ fontSize: '2.2rem' }} />
      </Box>
    </Box>
  );
}

export default HomeSection;
